<script>
  // import { saveAs } from "file-saver"
  import {
    education,
    jobOne,
    jobTwo,
    languages,
    technicalExperience,
    technologies,
  } from "$data/resume"
  import JobItem from "$components/JobItem.svelte"

  function downloadResume() {
    // saveAs("./Fabian Rodriguez Resume.pdf", "Fabian Rodriguez Software Resume")
    print()
  }
</script>

<div class="mx-auto mb-24 lg:w-9/12">
  <div>
    <h3 class="text-center">Resume</h3>
    <!-- <button -->
    <!--   on:click={downloadResume} -->
    <!--   class="mx-auto mt-6 flex items-center gap-x-4 rounded-xl border-0 bg-primary-600 py-2 px-8 text-lg font-bold text-white hover:bg-opacity-80 dark:bg-primary-400 dark:text-[#000621]" -->
    <!-- > -->
    <!--   Download <svg -->
    <!--     class="w-4 h-4" -->
    <!--     fill="currentColor" -->
    <!--     viewBox="0 0 20 20" -->
    <!--     xmlns="http://www.w3.org/2000/svg" -->
    <!--     ><path -->
    <!--       fill-rule="evenodd" -->
    <!--       d="M3.293 9.293a1 1 0 011.414 0L9 13.586V4a1 1 0 012 0v9.586l4.293-4.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z" -->
    <!--       clip-rule="evenodd" -->
    <!--     ></path></svg -->
    <!--   > -->
    <!-- </button> -->
  </div>

  <!-- Header -->
  <div class="mt-12 grid lg:grid-cols-3">
    <div class="text-left">
      <p>Fort Worth, Texas</p>
      <a href="https://www.github.com/rodrez">www.github.com/rodrez</a>
    </div>
    <div class="text-left lg:text-center">
      <h6>Fabian J. Rodriguez</h6>
    </div>
    <div class="text-left lg:text-right">
      <p>fabian.rodrez@gmail.com</p>
      <a
        class="text-primary-600 dark:text-primary-400"
        href="https://www.linkedin.com/in/f-rodrez/"
        >https://www.linkedin.com/in/f-rodrez/</a
      >
    </div>
  </div>

  <div class="mt-12">
    <p class="text-xl font-bold text-primary-600 dark:text-primary-400">
      Professional Experience
    </p>
    <div class="h-0.5 bg-slate-600"></div>

    <!-- Jobs -->
    <div class="mt-4">
      <!-- Job 1 Header -->
      <div class="grid lg:grid-cols-3">
        <p class="text-left font-bold">BI Analyst / Software Engineer</p>
        <p class="text-left font-bold lg:text-center">DB Schenker</p>
        <p class="text-left font-bold lg:text-right">2018 - 2023</p>
      </div>

      <JobItem job={jobOne} />
      <JobItem job={jobTwo} />
    </div>

    <!-- Education -->
    <div>
      <p class="mt-6 text-xl font-bold text-primary-600 dark:text-primary-400">
        Education
      </p>
      <div class="h-0.5 bg-slate-600"></div>
      <div class="mt-4">
        <!-- Education Header -->
        <div class="grid lg:grid-cols-3">
          <p class="text-left font-bold">{education.location}</p>
          <p class="text-left font-bold lg:text-center">{education.college}</p>
          <!-- <p class="text-left font-bold lg:text-right">{education.date}</p> -->
        </div>
        <div class="mt-2">
          <ul>
            <li>Major: {education.major}</li>
            <li>Minor: {education.minor}</li>
          </ul>
          <p class="font-bold leading-7">
            Programming Coursework:
            {#each education.courseWork as c}
              <span
                class="mx-1 flex-grow-0 items-center rounded bg-slate-200 py-0.5 px-1 font-normal text-[#0668d9] dark:bg-[#010819] dark:text-[#2461fb]"
                >{c}</span
              >
            {/each}
          </p>
        </div>
      </div>
    </div>

    <!-- Technical Experience -->
    <div>
      <p class="mt-6 text-xl font-bold text-primary-600 dark:text-primary-400">
        Technical Experience
      </p>
      <div class="h-0.5 bg-slate-600"></div>

      {#each technicalExperience as exp}
        <div>
          <p class="font-bold leading-7">
            <a class="text-primary-600 dark:text-primary-400" href={exp.href}
              >{exp.name}</a
            >
            - {exp.date}
          </p>
          <ul class="list-inside list-disc">
            <li>{exp.description}</li>
          </ul>
          <div class="flex flex-wrap gap-2">
            {#each exp.stack as tech}
              <span
                class="flex-grow-0 items-center rounded bg-slate-200 py-0.5 px-1 font-normal text-[#0668d9] dark:bg-[#010819] dark:text-[#2461fb]"
                >{tech}</span
              >
            {/each}
          </div>
        </div>
      {/each}
    </div>

    <!-- Languages and Technologies -->
    <div>
      <p class="mt-6 text-xl font-bold text-primary-600 dark:text-primary-400">
        Languages and Technologies
      </p>
      <div class="h-0.5 bg-slate-600"></div>
      <div>
        (Proficient):
        {#each languages.proficient as lang}
          <span
            class="mx-1 flex-grow-0 items-center rounded bg-slate-200 py-0.5 px-1 font-normal text-[#0668d9] dark:bg-[#010819] dark:text-[#2461fb]"
            >{lang}</span
          >
        {/each}
        (Familiar):
        {#each languages.familiar as lang}
          <span
            class="mx-1 flex-grow-0 items-center rounded bg-slate-200 py-0.5 px-1 font-normal text-[#0668d9] dark:bg-[#010819] dark:text-[#2461fb]"
            >{lang}</span
          >
        {/each}
        (Novice):
        {#each languages.novice as lang}
          <span
            class="mx-1 flex-grow-0 items-center rounded bg-slate-200 py-0.5 px-1 font-normal text-[#0668d9] dark:bg-[#010819] dark:text-[#2461fb]"
            >{lang}</span
          >
        {/each}
      </div>
      <div>
        (Proficient):
        {#each technologies.proficient as tech}
          <span
            class="mx-1 flex-grow-0 items-center rounded bg-slate-200 py-0.5 px-1 font-normal text-[#0668d9] dark:bg-[#010819] dark:text-[#2461fb]"
            >{tech}</span
          >
        {/each}
        (Familiar):
        {#each technologies.familiar as tech}
          <span
            class="mx-1 flex-grow-0 items-center rounded bg-slate-200 py-0.5 px-1 font-normal text-[#0668d9] dark:bg-[#010819] dark:text-[#2461fb]"
            >{tech}</span
          >
        {/each}
      </div>
    </div>
  </div>
</div>
